export const getParametres = (
  baseUrl,
  identifiantEntite,
) => `${baseUrl}/api/parametres/entite/${identifiantEntite}`;
